import { c as _c } from "react/compiler-runtime";
import { Link, Typography } from '@mui/material';
import { env } from '@cc-shopping/platform-env';
export function AdvertiserDisclosureMessage() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="headline" sx={{
      color: "primary.main"
    }}>You're our first priority.</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="headline" component="p" sx={{
      marginBottom: 3,
      color: "primary.main"
    }}>Every time.</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography component="p" sx={{
      marginBottom: 3
    }}>We believe everyone should be able to make financial decisions with confidence. While we don't cover every company or financial product on the market, we work hard to share a wide range of offers and objective editorial perspectives.</Typography>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography component="p" sx={{
      marginBottom: 3
    }}>So how do we make money? Our partners compensate us for advertisements that appear on our site or when you click to or take an action on their website. This compensation helps us provide tools and services - like free credit score access and monitoring. With the exception of mortgage, home equity and other home-lending products or services, partner compensation is one of several factors that may affect which products we highlight and where they appear on our site. Other factors include your credit profile, product availability and proprietary website methodologies.</Typography>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginBottom: 3
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <strong>do not influence our editors' opinions or ratings</strong>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <>{t0}{t1}{t2}{t3}<Typography component="p" sx={t4}>However, these factors{" "}{t5}, which are based on independent research and analysis. Our partners cannot pay us to guarantee favorable reviews.<Link href={`${env.NEXT_PUBLIC_NW_URL}p/our-partners`} underline="hover">{" "}Here is a list of our partners</Link>.</Typography></>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}